(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("commonninja-auth-sdk", [], factory);
	else if(typeof exports === 'object')
		exports["commonninja-auth-sdk"] = factory();
	else
		root["commonninja-auth-sdk"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// tslint:disable:variable-name
Object.defineProperty(exports, "__esModule", { value: true });
var CommonNinjaAuthSDKClass = /** @class */ (function () {
    function CommonNinjaAuthSDKClass(window, baseUrl, serviceName) {
        if (baseUrl === void 0) { baseUrl = ''; }
        if (serviceName === void 0) { serviceName = ''; }
        this.window = window;
        this._dashboardElmId = 'commonninja-dashboard-iframe';
        this._baseUrl = '';
        this._serviceName = '';
        this.elmId = 'commonninja-auth-iframe';
        this.activeCallback = null;
        this.eventTypes = {
            COMMONNINJA_AUTH_IFRAME_UPDATE: 'COMMONNINJA_AUTH_IFRAME_UPDATE',
            COMMONNINJA_AUTH_CLOSE: 'COMMONNINJA_AUTH_CLOSE',
            COMMONNINJA_AUTH_ERROR: 'COMMONNINJA_AUTH_ERROR',
            COMMONNINJA_AUTH_SUCCESS: 'COMMONNINJA_AUTH_SUCCESS',
            COMMONNINJA_DASHBOARD_PARENT_RELOAD: 'COMMONNINJA_DASHBOARD_PARENT_RELOAD',
            COMMONNINJA_DASHBOARD_IFRAME_UPDATE: 'COMMONNINJA_DASHBOARD_IFRAME_UPDATE',
            COMMONNINJA_DASHBOARD_PATH_CHANGE: 'COMMONNINJA_DASHBOARD_PATH_CHANGE',
        };
        this._baseUrl = baseUrl;
        this._serviceName = serviceName || '';
        if (typeof window !== 'undefined') {
            this.listenToMessages(window);
        }
    }
    CommonNinjaAuthSDKClass.prototype.listenToMessages = function (window) {
        var _this = this;
        // Listen to message from child window
        window.addEventListener('message', function (e) {
            if (!e.data) {
                return;
            }
            var eventData = {};
            try {
                eventData = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
            }
            catch (e) {
                // console.log('Unhandled json parsing.');
            }
            switch (eventData.type) {
                case EventTypes.COMMONNINJA_AUTH_CLOSE:
                    _this.activeCallback = null;
                    _this.removeIframe();
                    break;
                case EventTypes.COMMONNINJA_AUTH_SUCCESS:
                    // Triggering active callback
                    if (_this.activeCallback) {
                        var userData = typeof eventData.json === 'string' ? JSON.parse(eventData.json) : eventData.json;
                        _this.activeCallback(userData);
                        _this.activeCallback = null;
                    }
                    // Closing window or active iframe
                    _this.removeIframe();
                    break;
                case EventTypes.COMMONNINJA_AUTH_IFRAME_UPDATE:
                    var iframeElm = document.querySelector("#" + _this.elmId + "-elm");
                    if (!iframeElm) {
                        return;
                    }
                    if (eventData.height) {
                        iframeElm.style.height = eventData.height + "px";
                    }
                    if (eventData.width) {
                        iframeElm.style.width = eventData.width + "px";
                    }
                    break;
                case EventTypes.COMMONNINJA_DASHBOARD_IFRAME_UPDATE:
                    var dashboardIframeElm = document.querySelector("#" + _this._dashboardElmId);
                    if (!dashboardIframeElm) {
                        return;
                    }
                    if (eventData.height) {
                        dashboardIframeElm.style.height = eventData.height + "px";
                    }
                    if (eventData.width) {
                        dashboardIframeElm.style.width = eventData.width + "px";
                    }
                    break;
                case EventTypes.COMMONNINJA_DASHBOARD_PARENT_RELOAD:
                    // Reload only if there's no active callback
                    if (!_this.activeCallback) {
                        window.location.reload();
                    }
                    break;
                default:
                    return;
            }
        }, false);
    };
    CommonNinjaAuthSDKClass.prototype.createIframe = function (url, isVisible, width, height) {
        if (width === void 0) { width = 0; }
        if (height === void 0) { height = 0; }
        var iframe = document.createElement('iframe');
        iframe.style.width = width + "px";
        iframe.style.maxWidth = '90%';
        iframe.style.height = height + "px";
        iframe.style.maxHeight = '90%';
        iframe.style.overflow = 'auto';
        iframe.style.position = 'absolute';
        iframe.style.display = isVisible ? 'block' : 'none';
        iframe.style.zIndex = '10000';
        iframe.style.left = '50%';
        iframe.style.top = '50%';
        iframe.style.transform = 'translate(-50%, -50%)';
        iframe.frameBorder = '0';
        iframe.style.borderRadius = '3px';
        iframe.style.boxShadow = '0 1px 5px rgba(0,0,0,0.3)';
        iframe.src = url;
        iframe.id = this.elmId + "-elm";
        var overlay = document.createElement('div');
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.position = 'fixed';
        overlay.style.display = isVisible ? 'block' : 'none';
        overlay.style.zIndex = '9999';
        overlay.style.left = '0';
        overlay.style.top = '0';
        overlay.style.background = 'rgba(0,0,0,0.85)';
        overlay.id = this.elmId;
        overlay.appendChild(iframe);
        document.body.appendChild(overlay);
        this.attachListeners();
    };
    CommonNinjaAuthSDKClass.prototype.removeIframe = function () {
        var elm = document.getElementById(this.elmId);
        if (elm) {
            elm.parentNode.removeChild(elm);
        }
        this.removeListeners();
    };
    CommonNinjaAuthSDKClass.prototype.attachListeners = function () {
        window.addEventListener('keydown', this.handleKeyDown.bind(this));
        if (document.querySelector("#" + this.elmId)) {
            document.querySelector("#" + this.elmId).addEventListener('click', this.removeIframe.bind(this));
            document.querySelector("#" + this.elmId + " iframe").addEventListener('click', function (e) { return e.stopPropagation(); });
        }
    };
    CommonNinjaAuthSDKClass.prototype.removeListeners = function () {
        window.removeEventListener('keydown', this.handleKeyDown.bind(this));
        if (document.querySelector("#" + this.elmId)) {
            document.querySelector("#" + this.elmId).removeEventListener('click', this.removeIframe.bind(this));
            document.querySelector("#" + this.elmId + " iframe").removeEventListener('click', function () { return false; });
        }
    };
    CommonNinjaAuthSDKClass.prototype.handleKeyDown = function (e) {
        if (e.keyCode === 27) {
            this.removeIframe();
        }
    };
    CommonNinjaAuthSDKClass.prototype.getDashboardIframe = function (path, onLoad) {
        if (path === void 0) { path = ''; }
        var iframe = document.createElement('iframe');
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.overflow = 'auto';
        iframe.frameBorder = '0';
        iframe.src = this._baseUrl + "/embed/" + path;
        iframe.id = this._dashboardElmId;
        if (onLoad) {
            iframe.onload = onLoad;
        }
        return iframe;
    };
    CommonNinjaAuthSDKClass.prototype.login = function (callback) {
        var url = this._baseUrl + "/embed/login" + (this._serviceName ? "?serviceName=" + this._serviceName : '');
        this.createIframe(url, true, 420, 710);
        this.activeCallback = callback;
    };
    CommonNinjaAuthSDKClass.prototype.signup = function (callback) {
        var url = this._baseUrl + "/embed/signup" + (this._serviceName ? "?serviceName=" + this._serviceName : '');
        this.createIframe(url, true, 420, 780);
        this.activeCallback = callback;
    };
    CommonNinjaAuthSDKClass.prototype.logout = function (callback) {
        var url = this._baseUrl + "/embed/logout";
        this.createIframe(url, false);
        this.activeCallback = callback;
    };
    CommonNinjaAuthSDKClass.prototype.embedDashboardView = function (controllerElm, initPath, onLoad) {
        if (initPath === void 0) { initPath = ''; }
        if (document.getElementById(this._dashboardElmId)) {
            return null;
        }
        var iframe = this.getDashboardIframe(initPath, onLoad);
        controllerElm.appendChild(iframe);
        return controllerElm;
    };
    CommonNinjaAuthSDKClass.prototype.sendMessageToDashboard = function (message) {
        var iframeElm = document.getElementById(this._dashboardElmId);
        if (!iframeElm) {
            console.error('Dashboard iframe doesn\'t exist.');
            return;
        }
        iframeElm.contentWindow.postMessage(message, '*');
    };
    Object.defineProperty(CommonNinjaAuthSDKClass.prototype, "dashboardElmId", {
        get: function () {
            return this._dashboardElmId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommonNinjaAuthSDKClass.prototype, "baseUrl", {
        get: function () {
            return this._baseUrl;
        },
        set: function (baseUrl) {
            if (!baseUrl) {
                return;
            }
            this._baseUrl = baseUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommonNinjaAuthSDKClass.prototype, "serviceName", {
        get: function () {
            return this._serviceName;
        },
        set: function (serviceName) {
            if (!serviceName) {
                return;
            }
            this._serviceName = serviceName;
        },
        enumerable: true,
        configurable: true
    });
    return CommonNinjaAuthSDKClass;
}());
var EventTypes;
(function (EventTypes) {
    EventTypes["COMMONNINJA_AUTH_CLOSE"] = "COMMONNINJA_AUTH_CLOSE";
    EventTypes["COMMONNINJA_AUTH_SUCCESS"] = "COMMONNINJA_AUTH_SUCCESS";
    EventTypes["COMMONNINJA_AUTH_ERROR"] = "COMMONNINJA_AUTH_ERROR";
    EventTypes["COMMONNINJA_AUTH_IFRAME_UPDATE"] = "COMMONNINJA_AUTH_IFRAME_UPDATE";
    EventTypes["COMMONNINJA_DASHBOARD_PARENT_RELOAD"] = "COMMONNINJA_DASHBOARD_PARENT_RELOAD";
    EventTypes["COMMONNINJA_DASHBOARD_IFRAME_UPDATE"] = "COMMONNINJA_DASHBOARD_IFRAME_UPDATE";
    EventTypes["COMMONNINJA_DASHBOARD_PATH_CHANGE"] = "COMMONNINJA_DASHBOARD_PATH_CHANGE";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
// tslint:disable-next-line:variable-name
var CommonninjaAuthSDK = new CommonNinjaAuthSDKClass(typeof window !== 'undefined' ? (window || new Window()) : undefined, 'https://www.commoninja.com', 'commonninja');
if (typeof window !== 'undefined') {
    window['CommonninjaAuthSDK'] = CommonninjaAuthSDK;
}
exports.default = CommonninjaAuthSDK;


/***/ })
/******/ ]);
});